var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';

import { actions } from "../BasicReducer";
import RouteHandler from "../App/RouteHandler";
import SearchButton from "../Library/components/SearchButton";

import ResultsViewer from "./components/SemanticSearchResults";
import semanticSearchAPI from "./SemanticSearchAPI";

export default class SemanticSearchResultsView extends RouteHandler {
  static async requestState(requestParams, state) {
    const filters = state.semanticSearch ?
    state.semanticSearch.resultsFilters :
    { threshold: 0.4, minRelevantSentences: 5 };
    const args = requestParams.add(filters);
    const search = await semanticSearchAPI.getSearch(args);
    return [actions.set('semanticSearch/search', search)];
  }

  static renderTools() {
    return /*#__PURE__*/(
      _jsx("div", { className: "searchBox" }, void 0, /*#__PURE__*/
      _jsx(SearchButton, { storeKey: "library" })));


  }

  render() {
    return /*#__PURE__*/_jsx(ResultsViewer, {});
  }
}